module.exports = __webpack_public_path__ + "static/media/plane-reverse.7528c632.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/plane-reverse.png
// module id = 337
// module chunks = 0